interface ThemeStyle {
  connectColor: string
  background: string
  boxShadow: string
  primaryFontColor: string
  secondaryFontColor: string
  borderColor: string
  active: string
  retryLinkColor: string
  highlightAccent: string
  skeleton: string
  skeletonHighlight: string
}

interface BaseThemeStyle {
  light: ThemeStyle
  dark: ThemeStyle
}

/**
 * New 2022 > themes:
 * https://www.figma.com/file/PH3SUeDjMt6h7sR97xkyJx/App?node-id=6249%3A2522&t=w8DedOiaPYCfOwCG-0
 *
 */
export const BASE_THEME_STYLES: BaseThemeStyle = {
  light: {
    connectColor: '#B8B8B8',
    background: '#FFFFFF',
    boxShadow: '0px 2px 20px rgba(0, 0, 0, 0.15)',
    primaryFontColor: '#111',
    secondaryFontColor: '#4D4D4D',
    borderColor: '#999999',
    active: '#EFF3F6',
    highlightAccent: '#F3F3F3',
    retryLinkColor: '#0038FF',
    skeleton: '#ebebeb',
    skeletonHighlight: '#f5f5f5',
  },

  dark: {
    connectColor: '#585858',
    background: '#111111',
    boxShadow: '0px 1px 20px rgba(0, 0, 0, 0.45)',
    primaryFontColor: '#ffffff',
    secondaryFontColor: '#BBBBBB',
    borderColor: '#787878',
    active: '#393939',
    highlightAccent: '#393939',
    retryLinkColor: '#ffffff',
    skeleton: '#262626',
    skeletonHighlight: '#1F1F1F',
  },
}
